<template>
  <v-container class="max-width-1200">

    <v-row>
      <v-col>
        <v-img
          src="https://www.rubin.hu/wp-content/uploads/2015/05/16.jpg"
          max-width="800"
          contain
          class="ml-12 mx-auto">
        </v-img>
      </v-col>
    </v-row>

    <v-row class="text-justify justify-center">
      <v-col>

        <v-row class="justify-center">
          <v-col>
            <v-row>
              <v-col class="pb-0 headline text-uppercase">
                {{ $t('rubicon.technology.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('rubicon.technology.subtitle')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('rubicon.technology.text.01')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('rubicon.technology.text.02')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('rubicon.technology.text.03')}}
              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Technology',
    extends: DataComponentBase,

    data: () => ({

    }),

    methods: {

    },
  }
</script>
